import redirectInterceptor from "@/interceptors/redirect_interceptor";

export class AlertService {
  constructor(alertsFromJsonMapper, alertRulesFromJson, baseUrl) {
    this.alertsFromJsonMapper = alertsFromJsonMapper;
    this.alertRulesFromJson = alertRulesFromJson;
    this.baseUrl = baseUrl;
  }

  // Had to make baseUrl an input variable because the baseUrl that is used
  // to access the PA's dbs is kinda weirdly configured. (Fetched via an api)
  async getMany(accessToken, vesselName) {
    try {
      const response = await redirectInterceptor.get(
        `${this.baseUrl}/alert/vessel/${vesselName}`,
        {
          headers: {
            "Authorization": `${accessToken}`,
          },
        }
      );
      const result = response.data.map((datum) => this.alertsFromJsonMapper(datum));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateMany(accessToken, alerts) {
    const requestParams = {
      method: "PUT",
      url: `${this.baseUrl}/alert/vessel/`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
      data: alerts
    };

    try {
      const response = await redirectInterceptor.request(requestParams);
      const result = response.data.map((datum) => this.alertsFromJsonMapper(datum));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getRules(accessToken) {
    try {
      const response = await redirectInterceptor.get(`${this.baseUrl}/alert/fleet`, {
        headers: { "Authorization": `${accessToken}` },
      });
      const result = response.data.map((datum) => this.alertRulesFromJson(datum));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateManyFleet(accessToken, alertSetting, vessels) {
    const requestParams = {
      method: "PUT",
      url: `${this.baseUrl}/alert/fleet/`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
      data: { alert: alertSetting, selectedVessels: vessels }
    };
    try {
      await redirectInterceptor.request(requestParams);
    } catch (error) {
      throw error;
    }
  }

}
